import { useEffect } from "react";

export const useTrackUserLogin = (email: string | null, name: string | null) => {
    useEffect(() => {
        if (!email) return;
        const identify = () => window.umami?.identify(email, { name: name || "", email });
        if (window.umami) {
            identify();
            return;
        }
        // The Umami script (index.html) loads deferred and ad blockers often
        // block it: identify once it loads, and stay quiet if it never does.
        // (Logging an error here sent every blocked visit to Sentry.)
        const script = document.querySelector<HTMLScriptElement>('script[src="/u/script.js"]');
        script?.addEventListener("load", identify, { once: true });
        return () => script?.removeEventListener("load", identify);
    }, [email, name]);
};
